export enum VEBOUTGUARD_PROCESS {
  CANCEL = 'cancel',
  END = 'end',
  MOVE = 'move'
}
